import { TopCard, ChartSection, DashTable } from "./Components/index";
import "../../Assets/Scss/Dashboard_Custom_Card.scss";
import { useEffect, useState } from "react";
import {
  dashboardStatsURL,
  companyByIdUrl,
  fetchCompaniesUrl,
} from "../../Library/URLs";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";

const DashboardPage = () => {
  const User = useSelector((state) => state.payroll.User);
  const unique_id = uuid();

  const [allCompanies, setAllCompanies] = useState([]);
  const [dashboardStats, setDashboardStats] = useState({});

  useEffect(() => {
    FetchAllCompanies();
    FetchDashboardStats();
    //eslint-disable-next-line
  },[])

  const FetchAllCompanies = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      // company_id: User.company_id,
    };
    // setIsLoading(true);
    await axios
      .post(fetchCompaniesUrl, data)
      .then((res) => {
        // setIsLoading(false);
        if (res.data.success === true) {
          setAllCompanies(res.data.data);
          // console.log('all depart',res.data)
        }
        // console.log('all department res',res.data)
      })
      .catch((err) => {
        // console.log('Get all department error',err.message)
        // setIsLoading(false);
      });
  };

  const FetchDashboardStats = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      // company_id: User.company_id,
    };
    // setIsLoading(true);
    await axios
      .post(dashboardStatsURL, data)
      .then((res) => {
        // setIsLoading(false);
        if (res.data.success === true) {
          setDashboardStats(res.data.data);
          // console.log('all depart',res.data)
        }
        // console.log('all department res',res.data)
      })
      .catch((err) => {
        // console.log('Get all department error',err.message)
        // setIsLoading(false);
      });
  };

  return (
    <div className="Dashboard_Fill">
      <TopCard dashboardStats={dashboardStats} />
      <ChartSection dashboardStats={dashboardStats} />
      <DashTable allCompanies={allCompanies} />
    </div>
  );
};

export default DashboardPage;
